module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Paragraph-d962e4ce7726ac5a67b495b53e9366a2.svg";